import { useState, useEffect } from 'react';
import { Box } from '@mui/material';

import { TimerIcon } from '@icons/TimerIcon';
import { formatTime } from './helper';
import { useStyles } from './styles';

const CountDownBlock = ({
  timeInSec,
  onFinish,
}: {
  timeInSec: number;
  onFinish?: () => void;
}) => {
  const classes = useStyles();

  const [remainingTime, setRemainingTime] = useState(+timeInSec);

  useEffect(() => {
    if (remainingTime <= 0) return;

    const timerId = setTimeout(() => {
      setRemainingTime((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timerId);
  }, [remainingTime]);

  useEffect(() => {
    if (onFinish && remainingTime === 0) {
      onFinish();
    }
  }, [remainingTime]);

  return (
    <Box sx={classes.root}>
      <TimerIcon />
      <span>{formatTime(remainingTime)}</span>
    </Box>
  );
};

export default CountDownBlock;
